import Frame from "../../frame";
import {Outlet, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

function CDR() {

    const currentUser = useSelector(state => state.session.currentUser);
    let navigate = useNavigate();

    if(!currentUser) {
        navigate('/login');
    }

    return (<>
        <Frame>
            <Outlet/>
        </Frame>
    </>)
}

export default CDR;
